/* Progressive enhancement; navigation, product links and scene details work without JS. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root = document) => {
    root.querySelectorAll('.xkk-nav-group,.xkk-mobile-menu').forEach(menu => {
      if (menu.dataset.enhanced) return;
      menu.dataset.enhanced = 'true';
      const summary = menu.querySelector('summary');
      menu.addEventListener('keydown', e => {
        if (e.key === 'Escape') { menu.open = false; summary.focus(); }
      });
      menu.addEventListener('toggle', () => {
        if (menu.open) document.querySelectorAll('.xkk-nav-group,.xkk-mobile-menu').forEach(other => { if (other !== menu) other.open = false; });
      });
      if (menu.classList.contains('xkk-nav-group')) {
        menu.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') menu.open = true; });
        menu.addEventListener('pointerleave', () => { if (!menu.contains(document.activeElement)) menu.open = false; });
        menu.addEventListener('focusout', e => { if (!menu.contains(e.relatedTarget)) menu.open = false; });
      }
    });
    root.querySelectorAll('[data-xkk-motion]').forEach(section => {
      if (section.dataset.enhanced) return;
      section.dataset.enhanced = 'true';
      const button = section.querySelector('.xkk-motion-toggle');
      const sync = () => { button.hidden = reduced.matches; section.classList.toggle('has-motion', !reduced.matches); };
      sync(); reduced.addEventListener('change', sync);
      if ('IntersectionObserver' in window) new IntersectionObserver(entries => entries.forEach(entry => section.classList.toggle('motion-offscreen', !entry.isIntersecting))).observe(section);
      button.addEventListener('click', () => { const paused = section.classList.toggle('motion-paused'); button.setAttribute('aria-pressed', String(paused)); button.textContent = paused ? 'Play motion' : 'Pause motion'; });
    });
    root.querySelectorAll('[data-xkk-carousel]').forEach(section => {
      if (section.dataset.enhanced) return;
      section.dataset.enhanced = 'true';
      const track = section.querySelector('.xkk-picks__track');
      const controls = section.querySelector('.xkk-carousel-controls');
      const update = () => {
        controls.hidden = track.scrollWidth <= track.clientWidth + 2;
        controls.children[0].disabled = track.scrollLeft < 2;
        controls.children[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      controls.addEventListener('click', e => { const button = e.target.closest('button'); if (button) track.scrollBy({left: Number(button.dataset.direction) * track.clientWidth * .8, behavior: reduced.matches ? 'instant' : 'smooth'}); });
      new ResizeObserver(update).observe(track); track.addEventListener('scroll', update, {passive:true}); update();
    });
  };
  document.addEventListener('click', e => document.querySelectorAll('.xkk-nav-group[open],.xkk-mobile-menu[open]').forEach(menu => { if (!menu.contains(e.target)) menu.open = false; }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
